"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import { successIcon } from "../icons";
export function Notification(props) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "data-component": "Notification",
      className: "v3__notification v3__notification--inline v3__notification--success",
      children: [
        /* @__PURE__ */ jsx("span", { className: "v3__notification-icon v3__notification-icon--inline", children: successIcon() }),
        /* @__PURE__ */ jsxs("div", { className: "v3__notification-text v3__notification-text--column", children: [
          props.title && /* @__PURE__ */ jsx(
            "div",
            {
              className: "v3__notification-text-title",
              style: { display: "flex" },
              children: /* @__PURE__ */ jsx("span", { children: props.title })
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "v3__notification-text-message", children: props.message })
        ] }),
        props.action
      ]
    }
  );
}
